<div [formGroup]="group">
  <div class="mb-2 d-flex align-items-baseline">
    <label class="input-label-content" [htmlFor]="'input-phone'">{{ labelText }}</label>
  </div>
  <div class="d-flex">
    <py-dropdown
      *ngIf="phoneCodes"
      [hidden]="phoneCodes.length < 2"
      fieldName="countryPhoneCode"
      [formControlName]="'countryPhoneCode'"
      [options]="phoneCodes | filter: searchText : 'label'"
      [placeholder]=""
      [searchable]="true"
      (search)="onSearch($event)"
      [debounceTime]="0"
    ></py-dropdown>
    <py-reactive-form-input-field
      [group]="group"
      fieldName="phone"
      [resettable]="true"
      (handleReset)="onResetValue()"
      [placeholder]="phonePlaceholderText || ''"
    ></py-reactive-form-input-field>
  </div>
</div>
